import React, { useEffect, useRef, useState } from 'react';
import {connect} from 'react-redux';

import {ComponentsList, TrustedComponents} from './ComponentsList';


import {collapseSections, toggleSecurityViewMode, setJiraIssue} from '../../../state/actions/app'
import {setElementToExclude, setExclusionToRemove} from '../../../state/actions/exclusions'

import SecuritySummary from './Summary'
import ComponentsGroupedByCVE, { ExcludedComponentsGroupedByCVE } from './componentsGroupedByCVE';

import {CiFilter, FaFilter} from "../../../classes/icons"
import RangeSlider from '../../rangeSlider';
import DownloadSecurityCSV from './DownloadSecurityCSV';

const mapStateAsProps = state => ({
	readonly: state.projectInfo.projectInfo.readonly,
	privateMode: state.projectInfo.urlParams.mode,
	isSafeVersionAllowed: state.projectInfo.titleState.hasSafeVersion,
	summary: state.projectInfo.report.security,
	autofixPullRequests: state.projectInfo.report.autofixPullRequests,
	exclusions: state.projectInfo.exclusions,
	isLatest: state.projectInfo.isLatestReport,
	isSysAdmin: state.projectInfo.titleState.isUserAdmin,
	hasSecureCodeWarriorFeature: state.projectInfo.titleState.hasSecureCodeWarriorFeature,
	collapsed: state.summariesState.security,
	projectInfo: state.projectInfo,
	security: state.projectInfo.security,
	toggledLanguages: state.languagesFilter.toggledLanguages,
	viewModes: state.viewModeState,
	hasChaiFeature: state.projectInfo.titleState.hasChaiFeature,
	hasJiraIssues: !!state.projectInfo.jiraInfo
})

const mapDispatchAsProps = dispatch => ({
	newMitigations : (reason,newMitigation,isGlobalExclusionAvailable)=>dispatch(setElementToExclude(reason,newMitigation,isGlobalExclusionAvailable)),
	collapse: (current)=>dispatch(collapseSections("security", current)),
	removeMitigations : (advice,isGlobalExclusionAvailable)=>dispatch(setExclusionToRemove(advice,isGlobalExclusionAvailable)),
	toggleSecurityViewMode: () => dispatch(toggleSecurityViewMode()),
	setJiraIssue: (info) => dispatch(setJiraIssue(info))
})

const SecurityComponents = (props) => (<ComponentsList {...props}/>)
const SecurityExcludedComponents = (props) => (<ComponentsList {...props}/>)
const SecurityTrusted = (props) => (<TrustedComponents {...props}/>)

const Filters = ({filters, filterAdvisories, updateFiltersLoadingState})=>{
	const [showFilters, setShowFilter ] = useState(false)
	const [showFiltersOverview, setShowFiltersOverview] = useState(false)
	const editFilters = () => setShowFilter(!showFilters)
	const dropDownRef = useRef(null)
	const filterByEpss = (range) => {
		updateFiltersLoadingState(true)
		setTimeout(() => filterAdvisories(range, "epss"), 1000)
	}
	const filterByCvss = (range) => {
		updateFiltersLoadingState(true)
		setTimeout(() => filterAdvisories(range, "cvss"), 1000)
	}
	const getSelectedSeverities = () => {
		return Object.keys(filters.severity).filter((severity) => filters.severity[severity])
	}
	useEffect(() => {
		document.addEventListener("click", (event) => {
			if(dropDownRef && !dropDownRef.current.contains(event.target)) {
				setShowFilter(false)
			}
		})
	}, [])
	return <React.Fragment>
		<div ref={dropDownRef} className='security-filters'>
			<div className={`filters-overview ${showFiltersOverview && !showFilters ? "opacity-1" : ""}`}>
				<span>{`EPSS ${filters.epss[0]} - ${filters.epss[1]}`}</span>
				<span>|</span>
				<span>{`CVSS ${filters.cvss[0]} - ${filters.cvss[1]}`}</span>
				<span>|</span>
				<span>{`Severity: ${getSelectedSeverities().join(", ")}`}</span>
			</div>
			<div className='security-filters-label pointer' onMouseLeave={() => setShowFiltersOverview(false)} onMouseEnter={() => setShowFiltersOverview(true)} onClick={editFilters}>
				{showFilters ? <FaFilter style={{fontSize: "16px"}}/>: <CiFilter style={{fontSize: "20px"}}/>}
				<h3 style={{marginBottom: "0px", marginLeft: "2px"}}>Filters</h3>
			</div>
			<div className={`security-filters-dropdown ${showFilters ? "": "d-none"}`}>
				<div>
					<div className='severity-filters filter'>
						<div className='filter-label'>Severity</div>
						<div className='severities'>
							{Object.keys(filters.severity).map((severity, i) => {
								const severityState = filters.severity[severity]
								return <div key={`filter-${severity}-${i}`} className='severity' onClick={() => filterAdvisories(severity, "severity")}>
									<input id={`switch-filter-${severity}`} type="checkbox" key={"severity-"+severity+"-option"} readOnly checked={severityState} style={{cursor: "pointer"}}/>
									<span>{severity[0].toUpperCase()+severity.slice(1)}</span>
								</div>
							})}
						</div>
					</div>
					<div className='epss-filter filter'>
						<div className='filter-label'>EPSS</div>
						<div className='slider-container'>
							<RangeSlider initialMin={filters.epss[0]} initialMax={filters.epss[1]} min={0} max={100} step={0.1} showTooltipOnlyOnDrag={true} onChange={(range) => filterByEpss(range)}/>
						</div>
					</div>
					<div className='cvss-filter filter'>
						<div className='filter-label'>CVSS</div>
						<div className='slider-container'>
							<RangeSlider initialMin={filters.cvss[0]} initialMax={filters.cvss[1]} min={0} max={10} step={0.1} showTooltipOnlyOnDrag={true} onChange={(range) => filterByCvss(range) }/>
						</div>
					</div>
					<div className={`loader ${!filters.loading && "d-none"}`}>
						<span>Filtering...</span>
					</div>
				</div>
			</div>
		</div>
		
		
		
	</React.Fragment>
}


class Security extends React.Component{
	constructor(props){
		super(props)
		this.state = {
      securityAction: false,
      defectAction: false,
      ready: false,
      advisoriesSCWContent: {},
      cards: [],
      filters: {
		loading: false,
        severity: {
          critical: true,
          high: true,
          medium: true,
          low: true,
          others: false,
        },
        epss: [0, 100],
        cvss: [0, 10],
      },
      chai: {
        enabled: false,
      },
    };
		this.advicesData={};
		this.advisories = {}
		
		this.processedCards = {}
		this.preview = null
	}
	

	preprocess(){

		const section = this.props.security.section.standard
		this.setState({ready:true,showFilters: section.showFilters})
	}

	filterBySeverity(which) {
		const newStateValue=!this.state.filters.severity[which];
		if(newStateValue){
			window.$(`div[data-severity=${which}]`).show()
		}
		else{
			window.$(`div[data-severity=${which}]`).hide()
		}
		for(const wrapper of [...window.$(`.dependency-inner`)]){
			if([...window.$(wrapper).children()].filter(c=>window.$(c).css("display")!=="none").length===1){
				window.$(wrapper).parent().hide()
				window.$(wrapper).parent().next().hide()
			}
			else{
				window.$(wrapper).parent().show()
				window.$(wrapper).parent().next().show()
			}
		}
		const newState = {filters:{...this.state.filters}}
		newState.filters.severity[which] = newStateValue
		this.setState(newState)

	}
	filterByEpss(range) {
		if (this.props.viewModes.groupAdvisoryByCVE) return
		const [min, max] = range
		const dependencies = document.querySelectorAll("#dependency-list")
		for(let i = 0; i < dependencies.length; i++) {
			const {lib} = dependencies[i].dataset
			let numOfHiddenAdvices = 0;
			const advices = dependencies[i].querySelectorAll(".advice-wrapper")
			for(let j = 0; j < advices.length; j++) {
				const {epss} = advices[j].dataset
				const isHidden = advices[j].hidden
				if (isHidden){
					numOfHiddenAdvices++;
				}
				if (!isHidden && !epss && (min != 0 || max != 100)) {
					advices[j].hidden = true
					numOfHiddenAdvices++;
				} else if (isHidden && !epss && min == 0 && max == 100) {
					advices[j].hidden = false
					numOfHiddenAdvices--;
				}
				else if(!isHidden && (epss < min / 100 || epss > max / 100)) {
					advices[j].hidden = true
					numOfHiddenAdvices++;
				} 
				else if(isHidden && (epss >= min / 100 && epss <= max / 100)) {
					advices[j].hidden = false
					numOfHiddenAdvices--;
				}
				
			}
			const extraInfo = document.getElementById(lib+"extrainfo")
			if (numOfHiddenAdvices == advices.length){
				extraInfo.hidden = true
				dependencies[i].hidden = true
			} else {
				extraInfo.hidden = false
				dependencies[i].hidden = false
			}
		}
		
		
	}
	filterByCvss(range) {
		if (this.props.viewModes.groupAdvisoryByCVE) return
		const [min, max] = range
		const dependencies = document.querySelectorAll("#dependency-list")
		for(let i = 0; i < dependencies.length; i++) {
			const {lib} = dependencies[i].dataset
			let numOfHiddenAdvices = 0;
			const advices = dependencies[i].querySelectorAll(".advice-wrapper")
			for(let j = 0; j < advices.length; j++) {
				const {cvss} = advices[j].dataset
				const isHidden = advices[j].hidden
				if (isHidden){
					numOfHiddenAdvices++;
				}
				if (!isHidden && !cvss && (min != 0 || max != 10)) {
					advices[j].hidden = true
					numOfHiddenAdvices++;
				} else if (isHidden && !cvss && min == 0 && max == 10) {
					advices[j].hidden = false
					numOfHiddenAdvices--;
				}
				else if(!isHidden && (cvss < min || cvss > max)) {
					advices[j].hidden = true
					numOfHiddenAdvices++;
				} 
				else if(isHidden && (cvss >= min && cvss <= max)) {
					advices[j].hidden = false
					numOfHiddenAdvices--;
				}
				
			}
			const extraInfo = document.getElementById(lib+"extrainfo")
			if (numOfHiddenAdvices == advices.length){
				extraInfo.hidden = true
				dependencies[i].hidden = true
			} else {
				extraInfo.hidden = false
				dependencies[i].hidden = false
			}
		}
	}

	filterAdvisories(which, type){
		if(type==="severity") {
			this.filterBySeverity(which)
		}
		if(type==="epss") {
			this.setState({filters:{...this.state.filters, epss: which}})
			this.filterByEpss(which)
		}
		if(type==="cvss") {
			this.setState({filters:{...this.state.filters, cvss: which}})
			this.filterByCvss(which)
		}
		this.updateFiltersLoadingState(false)
	}

	updateFiltersLoadingState(state){
		this.setState({filters:{...this.state.filters, loading: state}})
	}
	
	async componentDidMount(){
		this.preprocess()
		if(this.props.hasChaiFeature) {
			let timer;
			try {
				timer = setTimeout(() => { throw new Error("Ping timeout") }, 10000)
				const res = await window.meterian.chai.ping()
				clearTimeout(timer)
				this.setState({chai: {...this.state.chai, enabled: res.status === 200 }})
			} catch(e) {
				clearTimeout(timer)
			}
		}
	}


	

	


	render(){
		if(!this.state.ready) return ""
		const groupAdvisoryByCVE = this.props.viewModes.groupAdvisoryByCVE
		const {display}=this.props;
		return(

			display?
				<React.Fragment>
					{!this.props.security.security.fullyExcluded || this.props.collapsed?
						<div className="row" id="defects-row">
							<div className="pb-3 col-lg-12">&nbsp;</div>
							<div className="col-lg-12 row pr-0 pb-2">
								<div className="col-md-5">
									<div>
										<h3 className="report-header mb-0 pb-0 d-inline" >
											<span name="dependencies-assessment"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY ASSESSMENT</span>
										</h3>
										<i tabIndex={0} className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)} onKeyUp={(e)=>{if(e.key.toLocaleLowerCase()=="enter") this.props.collapse(this.props.collapsed)}}></i>
										<DownloadSecurityCSV advisoriesMappedByCve={this.props.security.advisoriesMappedByCve}/>
										{!this.props.collapsed ? <span className="ml-2 pt-0 btn btn-link pointer" onClick={() => {
											this.props.toggleSecurityViewMode()
										}}>{groupAdvisoryByCVE ? "(View by component)": "(View by vulnerability)"}</span>
										:null}
									</div>
								</div>
								<div className="col-md-7 text-right pr-0 filters-container">
									{!this.props.collapsed && this.state.showFilters?
										<Filters filters={this.state.filters} filterAdvisories={this.filterAdvisories.bind(this)} updateFiltersLoadingState={this.updateFiltersLoadingState.bind(this)}/>:
										""
									}
								</div>
								
							</div>
							{
								this.props.collapsed?
									<SecuritySummary {...this.props} />:
									!groupAdvisoryByCVE?
									<SecurityComponents toggledLanguages={this.props.toggledLanguages} forExclusions={false} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} advicesData={this.advicesData} autofixPullRequests={this.props.autofixPullRequests}/> 
									:<ComponentsGroupedByCVE display={this.state.groupAdvisoryByCVE} chai={this.state.chai} advisoriesMappedByCve={this.props.security.advisoriesMappedByCve} parentProps={this.props} filters={this.state.filters} newMitigations={this.props.newMitigations}/>
							}
						</div>
						:
						null
					}
					{!this.props.collapsed && this.props.security.security.hasExclusions?
						!groupAdvisoryByCVE ? <div className="row mt-5 mb-5" id="mitigations-row">
								<div className="col-lg-8">
								
									<h3 className="report-header mb-0 pb-0 d-inline" >{this.collapsed && this.props.security.security.hasExclusions}<span name="security-exclusions"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY EXCLUSIONS</span> </h3>
									{this.props.security.security.fullyExcluded?<i className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)}></i>:null}
								</div>
								<SecurityExcludedComponents toggledLanguages={this.props.toggledLanguages} forExclusions={true} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} advicesData={this.advicesData} autofixPullRequests={this.props.autofixPullRequests}/>
								<SecurityTrusted toggledLanguages={this.props.toggledLanguages} assessments={this.props.security.security.assessments} parentProps = {this.props} parentState={this.state} />							
							</div>
							: <div className='row mt-5 mb-5' id="mitigations-row">
								<div className="w-100 mb-3 ml-3">
									<h3 className="report-header mb-0 pb-0 d-inline" >{this.collapsed && this.props.security.security.hasExclusions}<span name="security-exclusions"><i className="fa fa-shield" style={{color:"gray"}}></i> SECURITY EXCLUSIONS</span> </h3>
									{this.props.security.security.fullyExcluded?<i className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } id="security-minimizer" onClick={()=>this.props.collapse(this.props.collapsed)}></i>:null}
								</div>
								<ExcludedComponentsGroupedByCVE display={this.state.groupAdvisoryByCVE} chai={this.state.chai} advisoriesMappedByCve={this.props.security.advisoriesMappedByCve} parentProps={this.props} filters={this.state.filters} newMitigations={this.props.newMitigations}/>
							</div>
						:
						null
					}
				</React.Fragment>
				
			:null
		)
	}
}

export default connect(mapStateAsProps,mapDispatchAsProps)(Security);